$(() => {
  // 最近の検索条件と ~の薬剤師求人をエリアで絞り込むコンテンツの高さを余白なしで揃える
  const search_history_el = $('.m3p-histories__list');
  const search_histories = $('.m3p-histories__list li');
  const search_history_height = search_histories.outerHeight();
  const search_history_total_height = search_histories.length * search_history_height;
  
  const search_keywords_el = $('#m3p-keyword-from-search-condition .m3p-keyword__simple_list');
  const search_keywords_height = search_keywords_el.scrollHeight || search_keywords_el.innerHeight();
  
  if(search_history_total_height < search_keywords_height){
    search_history_el.css('height', `${search_keywords_height}px`);
  }else if(search_history_total_height > search_keywords_height){
    search_keywords_el.css('height', `${search_history_total_height}px`);
  }
});